import React from 'react';

import PricingProduct from '../component/pricing';
import SiteLoader from '../../../shared/components/loader/siteLoader';
import httpService from '../../../shared/services/http.services';
import { API_CONFIG } from '../../../shared/constants/api';
import '../component/pricingStyle.scss';

class Pricing extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            content: null
        };
    }

    componentDidMount() {
        this.getPricingPageContent();
    }

    /**
     * scrollToTag method is used to scroll to particular div.
     * it takes id and using that it finds offsetTop
     * @param {*} id  contains the id to what div needs to be in view
     */
    scrollToTag = (id) => {
        const element = document.getElementById(id.split("#")[1]);
        if (element) {
            const offset = element.offsetTop;
            window.scrollTo({ behavior: 'smooth', top: offset });
        }
    };

    /**
     * getPricingPageContent method is used to get api content for career page
     * it sets data as well and loading false
     */
    getPricingPageContent = async () => {
        try {
            const data = await httpService.get(API_CONFIG.path.pricing);
            if (data && data.acf) {
                this.setState({
                    isLoading: false,
                    content: data.acf
                });
            }

        } catch (error) {
            console.log(error);
        }
    };

    render() {
        return (
            <>
                { this.state.isLoading &&
                    <div className="loadingWrap" >
                        <SiteLoader />
                    </div>
                }
                { !this.state.isLoading && this.state.content &&
                    <PricingProduct scrollToTag={ this.scrollToTag } location={this.props.location.hash} content={ this.state.content } />
                }

            </>
        );
    }
}


export default Pricing;